import styles from './_genreComponent.module.scss'
import classnames from 'classnames'
import { songsPath } from '../../../utils/routeHelpers'
import Image from 'next/legacy/image'
import { Genre } from '../../../__generated__/graphql'

interface GenreProps {
  genre: Genre
  mode?: string
}

const GenreComponent: React.FC<GenreProps> = ({ genre, mode }) => {
  return (
    <a
      href={songsPath({ genreIds: [genre.id] })}
      className={classnames(styles.genreItem, {
        [styles.fullMode]: mode !== undefined && mode === 'full'
      })}
    >
      <div
        className={classnames(
          styles.genreHolder,
          { 'is-square': mode === undefined },
          { 'is-rectangle': mode !== undefined && mode === 'full' }
        )}
      >
        <Image src={genre.photo.medium} alt={genre.name} layout="fill" />

        {mode !== undefined && mode === 'full' && (
          <>
            <div className={styles.genreName}>{genre.name}</div>
          </>
        )}
      </div>

      {mode === undefined && (
        <div className={styles.genreName}>{genre.name}</div>
      )}
    </a>
  )
}

export default GenreComponent
